.head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 12px 14px 0;
  font-size: var(--t-body);
}

.scope {
  margin: 0;
  padding: 4px 14px 8px;
  color: var(--muted);
  font-size: var(--t-label);
}

.pad {
  padding: 0 14px 8px;
}

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  padding: 0 14px 10px;
  border-bottom: 1px solid var(--line-2);
}

.divider {
  width: 1px;
  height: 18px;
  background: var(--line-2);
}

.chip {
  padding: 2px 10px;
  border: 1px solid var(--line);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--ink-2);
  font: inherit;
  font-size: var(--t-min);
  font-weight: 650;
  cursor: pointer;
}

.chip[aria-pressed="true"] {
  border-color: var(--accent-line);
  background: var(--accent-w);
  color: var(--ink);
}

.chip:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.day {
  border-bottom: 1px solid var(--line-2);
}

.day:last-child {
  border-bottom: 0;
}

.dayHead {
  margin: 0;
  padding: 8px 14px 2px;
  color: var(--ink-2);
  font-size: var(--t-label);
  font-weight: 650;
}

.events {
  margin: 0;
  padding: 0 0 6px;
  list-style: none;
}

.event {
  display: grid;
  grid-template-columns: 7rem auto minmax(0, 1fr) minmax(5rem, auto) 6.5rem;
  gap: 4px 10px;
  align-items: baseline;
  padding: 4px 14px;
  font-size: var(--t-dense);
}

.time,
.actor {
  color: var(--muted);
}

.text {
  min-width: 0;
  color: var(--ink);
}

/* The empty last cell of an event with no ledger entry, so the grid keeps its columns. */
.none {
  display: block;
}

.seq {
  color: var(--accent);
  font-weight: 650;
  text-align: right;
}

@media (max-width: 720px) {
  .event {
    grid-template-columns: 1fr;
  }

  .seq {
    text-align: left;
  }
}
